import { atom } from 'jotai';
import LendingStatus from '@/types/LendingStatus';

// lending
export const btcfiLendingStatusesAtom = atom<LendingStatus[]>([]);
export const isLoadingBtcfiLendingStatusesAtom = atom(false);

// base ecosystem
export const isBaseReferrerAtom = atom(false);
